import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Ongoing: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.6px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.60995 3.30163C6.86296 3.16026 7.17264 3.16677 7.41947 3.31867L20.4195 11.3187C20.6561 11.4643 20.8002 11.7222 20.8002 12C20.8002 12.2778 20.6561 12.5357 20.4195 12.6813L7.41947 20.6813C7.17264 20.8332 6.86296 20.8397 6.60995 20.6984C6.35695 20.557 6.2002 20.2898 6.2002 20V4C6.2002 3.71017 6.35695 3.44301 6.60995 3.30163ZM7.8002 5.43165V18.5683L18.4738 12L7.8002 5.43165Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Ongoing;
